<template>
  <div class="search-page">
    <div class="tabs-content">
      <van-sticky :offset-top="0">
        <van-search ref="searchRef" class="search-content" :autofocus="true" v-model="searchVal" shape="round" background="#fff" :placeholder="$t('form.distributorNamePostCodeAddressCityVisitBa')" @input="(val) => handleSearch(val, 'search')" @clear="(val) => handleSearch(val, 'clear')">
          <van-icon slot="left" class="search-left-icon" name="arrow-left" size="23" @click="goBack" />
        </van-search>
        <FilterCustom :ref="`filterCustom`" :sortOption="sortOption" :pageType="pageType" :isFunnel="false" @changeFilter="confirmFilter" />
      </van-sticky>
      <van-pull-refresh v-model="isLoading" @refresh="pullDownRefreshFn">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedText" offset="60" :immediate-check="false" @load="pullUpLoadMoreFn">
          <Store ref="storeRef" :arr="sdList" @getCurrentLoc="getCurrentLoc" @getItemData="getItemData" />
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="oper-bottom-btn">
      <van-button v-if="checkPer(['admin', 'app:sd:updateSd']) && sdId" class="left-btn" @click="toPage('/salesDistribution/sdMapping')">{{ $t('shared.mapping') }}</van-button>
      <van-button v-if="checkPer(['admin', 'app:sdVisit:addOrUpdate']) && sdId" class="center-btn" @click="toPage('/salesDistribution/sdVisit')">{{ $t('shared.visitSellIn') }}</van-button>
      <van-button v-if="checkPer(['admin', 'app:eventSd']) && sdId" class="right-btn" @click="toPage('/event?pageType=salesDistribution')">{{ $t('shared.event') }}</van-button>
      <van-button v-if="checkPer(['admin', 'app:sd:addSd']) && !sdId" class="mapping-btn" type="info" @click="toPage('/salesDistribution/sdMapping')">{{ $t('button.createNewDistributorMapping') }}</van-button>
    </div>
    <XuVisitDialog ref="xuVisitDialogRef" :currentVisitInfo="currentVisitInfo" :customerId="sdId" :pageType="pageType" />
  </div>
</template>

<script>
import { sdAppListPageApi, arsSdVisitLastApi } from '@/api/salesDistribution'
import { Toast } from 'vant'
import Store from '../SalesDistribution/components/store'
import FilterCustom from '@/components/FilterCustom'
import { mapState } from 'vuex'
export default {
  name: 'SalesDistributionSearch',
  components: {
    Store,
    FilterCustom,
    XuVisitDialog: () => import('@/components/XuVisitDialog')
  },
  data () {
    return {
      isLoading: false, // 下拉的加载状态
      loading: false, // 上拉每一页的加载状态
      finished: false, // 上拉是否全部加载完毕
      sdList: [], // 文字列表
      paginationList: {
        page: 1,
        limit: 10,
        total: 0
      },
      geocoder: null,
      pageType: 'salesDistribution',
      filterData: {
        sortVal: 'distance-0',
        sortLabel: this.$t('shared.filter.distanceNearest')
      },
      sdId: '',
      checkedData: {
        lat: '',
        lng: ''
      },
      currentVisitInfo: {},
      searchVal: '',
      finishedText: this.$t('tips.nothingMore'),
      sortOption: [
        // { label: 'Sort By', value: '', },
        { label: this.$t('shared.filter.distanceNearest'), value: 'distance-0' },
        { label: this.$t('shared.filter.distanceFarthest'), value: 'distance-1' },
        { label: this.$t('shared.filter.distanceLatest'), value: 'updateTime-1' },
        { label: this.$t('shared.filter.distanceEarliest'), value: 'updateTime-0' },
        { label: this.$t('shared.filter.operationTopmost'), value: 'isAllot-1' },
        { label: this.$t('shared.filter.operationBottonmost'), value: 'isAllot-0' }
      ]
    }
  },

  watch: {
    $route (newVal) {
      this.$nextTick(() => {
        if (this.$route.meta.scrollY) {
          window.scrollTo(0, this.$route.meta.scrollY)
        }
      })
    }
  },

  // 路由离开前
  beforeRouteLeave (to, from, next) {
    // 可以访问组件实例 `this`
    // 把滚动的高度 保存到 路由对象的meta字段中的scrollY上
    from.meta.scrollY = window.scrollY
    // if (to.path === '/storeExpansion/storeMappin') {
    //   from.meta.scrollY = window.scrollY
    // } else
    if (to.path === '/salesDistribution/search') {
      from.meta.scrollY = 0
      this.$destroy()
    }
    next()
  },
  created () {
    this.finished = true
  },
  // mounted() {
  //   console.log('mounted')
  //   // this.geocoder = new google.maps.Geocoder()
  // },
  mounted () {
    this.finishedText = this.$t('tips.messageThirtySix')
    this.$nextTick(() => {
      // this.$refs.searchRef.focus()
      this.$el.querySelector('.van-field__control').focus()
      // this.$refs.searchRef.querySelector('input').focus()
    })
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo',
      globalData: 'globalData'
    })
  },
  methods: {
    getCurrentLoc (params) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getlocation(currentTimeLoc.lat, currentTimeLoc.lng, params.address)
    },
    getlocation (lat, lng, toAddress) {
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${toAddress}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    confirmFilter (data) {
      this.filterData = data
      this.paginationList.page = 1
      this.sdList = []
      this.finished = false
      this.loading = false
      this.getSdData(true)
      this.isLoading = false
    },
    // 获取频道文字列表xxxaaaxx
    async getSdData (isPullDown = false) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // 三星手机不能频繁获取当前定位
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getSdListData(currentTimeLoc)
    },
    getSdListData (currentTimeLoc = {}) {
      const {
        sortVal
      } = this.filterData
      const data = {
        ...this.paginationList,
        ...this.filterData,
        sortField: sortVal ? sortVal.split('-')[0] : '',
        order: sortVal ? sortVal.split('-')[1] : '',
        ...currentTimeLoc,
        search: this.searchVal
      }
      sdAppListPageApi(data)
        .then((result) => {
          Toast.clear()
          if (this.paginationList.page === 1) {
            this.sdList = []
          }
          // 没有就去请求
          this.paginationList.total = result.data.totalRow
          result.data.list.forEach(subItem => {
            if (subItem.shelfList) {
              subItem.newShelfList = subItem.shelfList.map(shelfItem => shelfItem.productName)
            } else {
              subItem.newShelfList = []
            }
          })
          // 把新数组 与 原来的 数组 进行 合并
          this.sdList = [...this.sdList, ...result.data.list]
          // 把 loading 设置为false，表示 可以进行 下一次请求了
          this.paginationList.page++
          this.loading = false
          if (this.sdList.length === Number(this.paginationList.total)) {
            this.finished = true
          }
          this.finishedText = this.$t('tips.nothingMore')
        })
        .catch((err) => {
          console.log('err', err)
          this.loading = false
          this.finished = true
        })
    },

    // 上拉加载更多
    pullUpLoadMoreFn () {
      // 切换频道的时候，只有articleList 不为空，才触发 上拉加载更多的函数
      if (this.sdList.length > 0) {
        // 1. 发请求 2. 拿数据，合并
        this.getSdData()
      }
    },
    // 下拉刷新
    pullDownRefreshFn () {
      // this.sdList = []
      this.resetPage()
      this.getSdData(true)
      this.isLoading = false
    },
    resetPage () {
      this.paginationList = {
        page: 1,
        limit: 10,
        total: 0
      }
      this.sdList = []
      this.finished = false
      this.loading = false
    },
    handleSearch (val, type) {
      if (this.searchVal === '') {
        this.paginationList.page = 1
        this.sdList = []
        this.finished = false
        this.loading = false
        this.isLoading = false
      }
      if (type === 'search' && this.searchVal !== '') {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          clearTimeout(this.timer)
          this.paginationList.page = 1
          this.sdList = []
          this.finished = false
          this.loading = true
          this.isLoading = false
          this.getSdData()
        }, 800)
      } else {
        this.$nextTick(() => {
          // this.$refs.searchRef.focus()
          this.$el.querySelector('.van-field__control').focus()
        })
      }
    },
    toPage (url) {
      if (url === '/salesDistribution/sdMapping') {
        this.$router.push(`${url}?customerId=${this.sdId}`)
      } else if (url === '/salesDistribution/sdVisit') {
        if (!this.sdId) {
          Toast(this.$t('form.ruleTipsOne'))
          return
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsSdVisitLastApi(this.sdId, '1').then(res => {
          Toast.clear()
          this.currentVisitInfo = res.data
          if (res.data.lastType === 0) {
            this.$router.push(`${url}?customerId=${this.sdId}`)
          } else {
            this.$refs.xuVisitDialogRef.dialogShow = true
          }
        })
      } else {
        this.$router.push(url)
      }
    },
    getItemData (data) {
      this.sdId = data.id || ''
      this.checkedData = data
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
.search-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  .search-content {
    padding: 8px 10px;
    /deep/.van-cell {
      line-height: 20px;
    }
  }
  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }
  .van-cell-info {
    // position: relative;
    display: flex;
    justify-content: space-between;
    // top: 53px;
    height: 35px;
    padding: 0 10px;
    font-size: 12px;
    background-color: #dce5f6;
    .channel-total {
      display: flex;
      align-items: center;
      flex: 1;
      .label-name {
        width: 60px;
      }
      .label-value {
        flex: 1;
        width: 66px;
      }
    }
    .channel-filter {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 50%;
      padding-left: 10px;
      border-left: 1px solid #c8d6f1;
      &:first-child {
        border-left: none;
      }
      .filter-label {
        flex: 1;
      }
    }
  }
  .tabs-content {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    padding-bottom: 43px;
  }
  .oper-bottom-btn {
    .left-btn {
      background-color: #307bff;
      color: #fff;
    }
    .center-btn {
      color: #fff;
      margin: 0 1px;
      background-color: #0db00b;
    }
    .right-btn {
      background-color: #ee541b;
    }
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
      font-size: 16px;
    }
  }
  .map-img {
    width: 30px;
    height: 30px;
  }
  /deep/.van-pull-refresh {
    .van-list {
      background-color: #fff;
    }
  }
  /deep/.van-sticky {
    z-index: 999;
  }
}
</style>
